module.exports = __webpack_public_path__ + "img/luna child_lw.258677e7.png";